import './style.css';
import { motion } from 'framer-motion';
import { range } from 'lodash';
import iReducer from 'renderer/Global/State/reducerInterface';
import InventoryItem from '../InventoryItem';
import { useState, useEffect } from 'react';
import {
  ChevronDown,
  ChevronUp,
} from 'react-feather';
import PaginationContainer from '../PaginationContainer';

export default function Inventory({ state, dispatch }: iReducer) {
  const [showInventory, setShowInventory] = useState(true);

  const toggleInventory = () => {
    setShowInventory((showInventory) => !showInventory);
  };

  let pageSize = 2;
  let [page, setPage] = useState(1);

  const [inventoryItems, setInventoryItems] = useState(
    state.inventory.getInventoryItems()
  );
  const [searchQuery, setSearchQuery] = useState('');
  const [showMostRecent, setShowMostRecent] = useState(true);

  const currentQuery = (query: string) => {
    setSearchQuery(query);
  };

  const updateMostRecent = (checked: boolean) => {
    setShowMostRecent(checked);
  };

  useEffect(() => {
    let _inv = state.inventory.getInventoryItems();

    // Remove items with amount 0
    _inv = _inv.filter((_invItem) => _invItem.amount > 0);

    // Alphabetical or Most Recent Order
    if (!showMostRecent)
      _inv = _inv.sort((a, b) =>
        a.item.displayName.localeCompare(b.item.displayName)
      );

    // Search Query
    if (searchQuery) {
      setPage(1);
      _inv = _inv.filter((_invItem) =>
        _invItem.item.displayName
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    // Pagination Slice
    const lower = pageSize * (page - 1);
    const upper = lower + pageSize;

    _inv = _inv.slice(lower, upper);

    if (_inv.length) {
      setInventoryItems(_inv);
    } else {
      if (page > 0) {
        setPage((page -= 1));
      }
    }
  }, [page, showMostRecent, searchQuery, state]);

  return (
    <motion.div
      className="inventoryTable"
      initial={{ opacity: 0 }}
      animate={{
        opacity: 1,
      }}
      transition={{
        delay: 0.1,
        duration: 0.5,
      }}
    >
      <div className="inventoryHeader">
        <div>Current Inventory</div>
        <div>
          {showInventory ? (
            <ChevronUp
              className="toggleIcon"
              size={26}
              onClick={() => toggleInventory()}
            />
          ) : (
            <ChevronDown
              className="toggleIcon"
              size={26}
              onClick={() => toggleInventory()}
            />
          )}
        </div>
      </div>

      <div className="inventoryCustomization">
        <div className="inventorySearch">
          <div>Search</div>
          <input className="" onChange={(e) => currentQuery(e.target.value)} />
          <div>Most Recent</div>
          <input
            type="checkbox"
            checked={showMostRecent}
            onChange={(e) => updateMostRecent(e.target.checked)}
          />
        </div>
      </div>
      {showInventory
        ? range(0, Object.keys(inventoryItems).length).map((i) => (
            <InventoryItem
              key={i}
              state={state}
              dispatch={dispatch}
              inventoryItem={inventoryItems[i]}
              currInventoryItems={inventoryItems}
            />
          ))
        : null}

      <PaginationContainer page={page} lastPage={5} setPage={setPage} />
    </motion.div>
  );
}
